<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
  </div>
  <div class="col-3"></div>
  <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
</div>
<div class="modal-body mx-3">
  <div class="row mb-3">
    <div class="col-12">
      <label for="UserRecipientName" class="form-label">{{'IDS_RECIPIENT'|translate}}</label>
      <input type="text"  class="form-control" [ngModel]="UserRecipientName" name="UserRecipientName" id="UserRecipientName" readonly>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label for="subject" class="form-label">{{'IDS_MESSAGE_SUBJECT'|translate}}</label>
      <input name="subject" class="form-control" id="subject" [(ngModel)]="subject">
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label for="messageContent" class="form-label">{{'IDS_TEXT'|translate}}</label>
      <app-memo-editor id="messageContent" name="messageContent" [(ngModel)]="messageContent" [style]="{'height':'200px'}"></app-memo-editor>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 col-md-3">
      <button style="width: 100%;" class="btn-gold fw-bold text-uppercase mb-3" (click)="saveMessageClicked()">{{'IDS_SEND'|translate}}</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 col-md-3">
      <button style="width: 100%;" class="admin-new fw-bold text-uppercase" type="button" (click)="activeModal.close(false)">{{'IDS_BTN_ABORT' | translate}}</button>
    </div>
  </div>
</div>
